import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  getAdminAppBaseUrl,
  mapAdminPathToAdminSpa,
  redirectToAdminSpa,
} from '../../utils/adminAppUrl';
import RouteGateFallback from '../ui/RouteGateFallback';

/**
 * Phase 2: landlord SPA no longer hosts platform admin UI.
 * Always send /admin/* to the admin host when configured.
 */
const AdminHostRedirect: React.FC = () => {
  const location = useLocation();
  const adminBase = getAdminAppBaseUrl();

  useEffect(() => {
    if (adminBase) {
      redirectToAdminSpa(location.pathname);
    }
  }, [adminBase, location.pathname]);

  if (adminBase) {
    return <RouteGateFallback variant="admin" message="Opening platform admin…" />;
  }

  const fallbackPath = mapAdminPathToAdminSpa(location.pathname);
  const hint = `https://admin.tenantplus.co.ke${fallbackPath === '/' ? '' : fallbackPath}`;

  return (
    <div style={{ minHeight: '60vh', display: 'grid', placeItems: 'center', padding: 24, textAlign: 'center' }}>
      <div>
        <h1 style={{ fontSize: 20, marginBottom: 8 }}>Platform admin moved</h1>
        <p style={{ opacity: 0.75, maxWidth: 420, margin: '0 auto 16px' }}>
          Set <code>REACT_APP_ADMIN_URL</code> on this app (e.g. <code>https://admin.tenantplus.co.ke</code>)
          and redeploy, or open the admin host directly.
        </p>
        <a href={hint}>{hint}</a>
      </div>
    </div>
  );
};

export default AdminHostRedirect;
